import { render, staticRenderFns } from "./teamRoleConfig.vue?vue&type=template&id=58f4361e&"
import script from "./teamRoleConfig.vue?vue&type=script&lang=ts&"
export * from "./teamRoleConfig.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports